//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


import { date } from 'quasar'
import { getWorkShiftIconName } from '../../components/helpers.js'
import BrigadeFieldEditor from './BrigadeFieldEditor.vue'

export default {
  components: {
    BrigadeFieldEditor
  },
  props: {
    value: {
      type: Object,
      default: null
    },
    label: {
      type: String,
      default: 'Бригада'
    },
    labelColor: {
      type: String,
      default: 'black'
    },
    placeholder: {
      type: String,
      default: undefined
    },
    clearable: {
      type: Boolean,
      default: true
    },
    readonly: {
      type: Boolean,
      default: false
    },
    shortOnly: {
      type: Boolean,
      default: false
    },
    hideBottomSpace: {
      type: Boolean,
      default: false
    },
    rules: {
      type: Array,
      default: null
    },
    // {id, name, workShift, workDate}
    options: {
      type: Array,
      default: function () {
        return []
      }
    }
  },
  data: () => {
    return {
      localValue: null,
      editorOpened: false,
      editorValue: {
        id: null,
        name: null,
        workAreas: [],
        workShift: null
      }
    }
  },
  computed: {
    addBrigadeAccess: function () {
      return !this.readonly && !this.shortOnly
    },
    optionsLocal: function () {
      const options = [...this.options]
      if (this.addBrigadeAccess) {
        options.push({ _btn: 'add' })
      }
      return options
    }
  },
  watch: {
    localValue: function () {
      this.$emit('input', this.localValue)
    }
  },
  created: function () {
    this.localValue = this.value
  },
  mounted: function () {
    this.validate()
  },
  methods: {
    getDate: function (brigade) {
      return brigade && brigade.workDate ? date.formatDate(brigade.workDate, 'DD.MM') : null
    },
    onClear: function () {
      this.localValue = {}
      this.validate()
    },
    onAdd: function () {
      if (this.value) {
        this.editorValue = JSON.parse(JSON.stringify(this.value))
      }
      this.editorOpened = true
    },
    onApplyChanges: function () {
      const value = {}
      value.id = this.editorValue.id
      value.name = this.editorValue.name
      value.workAreas = this.editorValue.workAreas
      value.workShift = this.editorValue.workShift.key
      value.workDate = this.editorValue.workDate

      this.localValue = value
      this.validate()
      this.onCancelChanges()
    },
    onCancelChanges: function () {
      this.editorValue.id = null
      this.editorValue.name = null
      this.editorValue.workAreas = []
      this.editorValue.workShift = null
      this.editorValue.workDate = null

      this.editorOpened = false
    },
    validate: function () {
      if (this.$refs.field) {
        return this.$refs.field.validate()
      }
    },
    getWorkShiftIconName: function (workShift) {
      if (workShift && workShift.key) {
        return getWorkShiftIconName(workShift.key)
      } else {
        return ''
      }
    }
  }
}
